import FinanceXImport from './FinanceXImport.container';

export default FinanceXImport;
